import React from 'react';
import { camerasApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

export default function Cameras() {
  const { data: cameras, loading, error, reload } = useApiData(() => camerasApi.list());

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Cameras</h1>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={cameras?.length === 0} emptyLabel="No cameras added yet.">
        <div className="grid md:grid-cols-3 gap-4">
          {cameras?.map((c) => (
            <div key={c.id} className="glass rounded-xl overflow-hidden">
              <div className="aspect-video bg-black/40 flex items-center justify-center text-white/20 text-xs">
                {c.snapshot_url ? (
                  <img src={c.snapshot_url} alt={c.name} className="w-full h-full object-cover" />
                ) : (
                  'No preview'
                )}
              </div>
              <div className="p-3">
                <div className="flex items-center justify-between">
                  <p className="font-medium text-sm">{c.name}</p>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${c.is_online ? 'bg-green-500/20 text-green-400' : 'bg-white/10 text-white/40'}`}>
                    {c.is_online ? 'Online' : 'Offline'}
                  </span>
                </div>
                {c.room_name && <p className="text-white/40 text-xs mt-1">{c.room_name}</p>}
              </div>
            </div>
          ))}
        </div>
      </StateBlock>
      <p className="text-white/30 text-xs mt-6">
        Live streaming and playback are available in the mobile app and
        customer portal; this foundation page covers browsing only.
      </p>
    </div>
  );
}
